import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, OtpInput, Text } from '@datanomik/core-ui';

import type { MfaChallenge } from '../model/types';

const TOKEN_LENGTH = 6;

interface MfaTokenFormProps {
  challenge: MfaChallenge;
  busy: boolean;
  onSubmit: (token: string, trustDevice: boolean) => void;
}

export function MfaTokenForm({ challenge, busy, onSubmit }: MfaTokenFormProps) {
  const { t } = useTranslation();
  const [token, setToken] = useState('');
  const [trustDevice, setTrustDevice] = useState(true);

  const complete = token.length === TOKEN_LENGTH;

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        if (complete) onSubmit(token, trustDevice);
      }}
      className="flex flex-col gap-5"
    >
      {challenge.qrCode && (
        <div className="flex flex-col items-center gap-3 rounded-xl bg-card p-5">
          <Text variant="body-sm" tone="muted" className="text-center">
            {t('Scan this code with your authenticator app.')}
          </Text>
          <img
            src={challenge.qrCode}
            alt={t('Authentication QR code')}
            className="size-40 rounded-lg bg-white p-2"
          />
        </div>
      )}

      <OtpInput
        value={token}
        onChange={setToken}
        length={TOKEN_LENGTH}
        autoFocus
        label={t('Authentication code')}
        onComplete={(value) => { if (!busy) onSubmit(value, trustDevice); }}
      />

      <Checkbox
        label={t('Trust this device')}
        checked={trustDevice}
        onCheckedChange={(value) => setTrustDevice(value === true)}
      />

      <Button type="submit" className="w-full" loading={busy} disabled={!complete}>
        {t('Continue')}
      </Button>
    </form>
  );
}
